import React from 'react'
import {Route, Routes} from 'react-router-dom'
import {Resources} from './views/Resources'
import {PageTitle} from '../../../_metronic/layout/core'
import {useIntl} from 'react-intl'
import {ResourceBreadCrum} from './core/_constants'
import ResourceDetail from './components/ResourceDetail'
// import ResourcesDetails from './components/ResourcesDetails'
//import { KTSVG } from '../../../_metronic/helpers'
import {ToolTipUI} from '../widgets/components/UI/ToolTipUI'
import './styles/resources.scss'

const ResourcesRoutes = () => {
  const {formatMessage} = useIntl()
  const {ResourcesBreadCrum, ResourcesDocBreadCrum} = ResourceBreadCrum()
  // function storeSearchValue(value: string): void {
  //   throw new Error('Function not implemented.')
  // }

  return (
    <div className='mt-3 px-6'>
      <Routes>
        <Route
          index
          element={
            <div style={{position: 'relative'}}>
              <PageTitle
                breadcrumbs={ResourcesBreadCrum}
                description={formatMessage({id: 'Resources'})}
              >
                {formatMessage({id: 'Resources'})}
              </PageTitle>
              <div className='resources-tooltip'>
                <ToolTipUI
                  tooltipText={formatMessage({
                    id: 'Get all sorts of templatized documents for your fundraising needs',
                  })}
                />
              </div>
              <Resources />
            </div>
          }
        />
        <Route
          path='/:tabName/:resourceId'
          element={
            <div style={{position: 'relative'}}>
              <PageTitle
                breadcrumbs={ResourcesDocBreadCrum}
                description={formatMessage({id: 'Resources'})}
              >
                {formatMessage({id: 'Resources123'})}
              </PageTitle>
              <div className='resources-detail-tooltip'>
                <ToolTipUI
                  tooltipText={formatMessage({
                    id: 'Get all sorts of templatized documents for your fundraising needs',
                  })}
                />
              </div>
              <ResourceDetail />
            </div>
          }
        />
      </Routes>
    </div>
  )
}

export default ResourcesRoutes
